import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Input_ } from "monica-alexandria";
import { Sales_Lead_Avatar } from "./Sales_Lead_Avatar";
import {
    read_member_keys,
    read_member_name,
    read_member_render_key
} from "../utils/sales_helpers";

const ProspectLeadActions = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: flex-start;
    gap: var(--normalPads);
    margin-bottom: 1rem;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;

    @media (max-width: 72rem) {
        grid-template-columns: 1fr;
    }
`;

const ProspectLeadSearchTeam = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: nowrap;
    width: 100%;
    max-width: 100%;
    min-width: 0;
`;

const ProspectLeadSearch = styled.div`
    flex: 1 1 auto;
    min-width: 0;
    margin-bottom: var(--smallPads);

    input {
        padding-top: 1rem;
    }

    label {
        display: none;
    }
`;

const ProspectLeadTeam = styled.div`
    display: flex;
    gap: 0.6rem;
    flex-wrap: wrap;
    flex: 0 0 auto;
    justify-content: flex-end;
    max-width: 28rem;
    min-width: 0;
`;

const ProspectLeadTeamMember = styled.div`
    width: 2.8rem;
    height: 2.8rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0.2rem solid ${p => p.active ? "var(--main)" : "transparent"};
    cursor: pointer;
    overflow: hidden;

    > div {
        width: 100%;
        height: 100%;
    }
`;

/**
 * Reads whether one assigned member avatar is selected.
 */
const read_member_selected = (member, selectedTeamMemberKeys) => {
    const memberKeys = read_member_keys(member);

    return memberKeys.some((memberKey) => selectedTeamMemberKeys.includes(memberKey));
};

/**
 * Renders the Prospect Leads board header controls and assigned-member filter.
 */
export const Sales_Header = (props) => {
    const { t } = useTranslation();

    return (
        <ProspectLeadActions>
            <ProspectLeadSearchTeam>
                <ProspectLeadSearch>
                    <Input_
                        type="text"
                        placeholder={t("Search")}
                        value={props?.searchTerm}
                        onChange={(event) => props?.onSearchTerm(event.target.value)}
                    />
                </ProspectLeadSearch>
                <ProspectLeadTeam>
                    {props?.teamMembers?.map((member, memberIndex) => (
                        <ProspectLeadTeamMember
                            key={read_member_render_key(member, memberIndex)}
                            title={read_member_name(member)}
                            active={read_member_selected(member, props?.selectedTeamMemberKeys)}
                            onClick={() => props?.onTeamMember(member)}
                        >
                            <Sales_Lead_Avatar
                                member={member}
                                label={read_member_name(member)}
                                name={read_member_name(member)}
                                size="2.8rem"
                                showDefaultImage
                            />
                        </ProspectLeadTeamMember>
                    ))}
                </ProspectLeadTeam>
            </ProspectLeadSearchTeam>
        </ProspectLeadActions>
    );
};
